import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { baseContainer } from "./src/index";

export let reactPlugin = null;
export let appInsights = null;

const createTelemetryService = () => {
  const initialize = (appInsightsSetts) => {
    const { instrumentationKey, enable } = appInsightsSetts;
    reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        maxBatchInterval: 100,
        disableFetchTracking: true,
        enableAutoRouteTracking: true,
        enableAjaxPerfTracking: true,
        enableDebug: true,
        autoTrackPageVisitTime: true,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: baseContainer.getHistory(),
          },
        },
      },
    });

    if (enable) {
      appInsights.loadAppInsights();
      appInsights.trackPageView();
      appInsights.trackPageViewPerformance();
    }
  };
  return { initialize };
};

 
export const ai = createTelemetryService();
